import { Component, ViewChild, Input } from '@angular/core';

import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { SupplierSchedule } from 'app/buffer-graph/models/suppliers-schedules/supplier-schedule';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column';
import { Formatters } from 'app/slick-grid/models/formatters';

@Component({
    selector: 'suppliers-schedules',
    templateUrl: './suppliers-schedules.component.html',
    styleUrls: ['./suppliers-schedules.component.css']
})
export class SuppliersSchedulesComponent extends TabComponentBase<SupplierSchedule, any> {
    constructor(graphService: BufferGraphService) {
        super(graphService);

        this.dataView = new Slick.Data.DataView<any>();
        this.options = { syncColumnCellResize: true, multiColumnSort: true, editable: false };
        this.columns = [
            { id: 'rang', field: 'rang', name: 'Rang', sortable: true },
            { id: 'code ', field: 'code', name: 'Code', sortable: true },
            { id: 'name', field: 'name', name: 'Supplier', sortable: true },
            { id: 'schedule', field: 'schedule', name: 'OrderSchedule', sortable: true },
            { id: 'moa', field: 'moa', name: 'Moa', sortable: true, formatter: (r, c, v) => Formatters.numberFormatter(r, c, v, 2) },
            { id: 'moq', field: 'moq', name: 'Moq', sortable: true, formatter: (r, c, v) => Formatters.numberFormatter(r, c, v, 2) },
        ];
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    @Input()
    private set schedules(schedules: SupplierSchedule[]) {
        this.dataView.setItems(schedules);
    }

    protected sku: string;

    protected warehouseCode: string;

    protected canSend: boolean;

    protected getExportData = this.getExportDataByDefault;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/suppliers-schedules.component/suppliers-schedules.component.ts